module.exports = __webpack_public_path__ + "media/get-started/lines-a0328935.png";